import { lazy, ReactNode, Suspense, useEffect, useState } from 'react';
import useStyles from './styles';
import { useSelector } from 'react-redux';
import { deferImport, isExpired, isTrialPeriod } from 'utils/helper';
import UserInterface from 'interface/user';
import { API_EXCEPTION } from 'enums/api-exception.enums';
/* Components */
import { ClassNameMap } from '@mui/material';
import Header from 'components/header';
import LoadingModal from 'components/commons/loading-modal';

/* Lazy load component */
const ResetTrialPopup = lazy((): Promise<any> => {
  return deferImport(import('components/popups/reset-trial-popup'));
});
const SubscriptionErrorPopup = lazy((): Promise<any> => {
  return deferImport(import('components/popups/subscription-error-popup'));
});
/* End */

interface AuthenticatedLayoutProps {
  children: ReactNode;
  user?: UserInterface | null;
}

const AuthenticatedLayout = ({ children, user }: AuthenticatedLayoutProps) => {
  const classes: ClassNameMap = useStyles();
  const subscriptionError: API_EXCEPTION = useSelector(
    (state: any) => state.pageReducer.subscriptionError
  );
  const [openResetTrialPopup, setOpenResetTrialPopup] =
    useState<boolean>(false);

  useEffect(() => {
    if (user && isTrialPeriod(user) && isExpired(user))
      setOpenResetTrialPopup(true);
  }, [user]);

  return (
    <>
      <div className={classes.root}>
        <Header />
        <div className={classes.content}>{children}</div>
      </div>

      <Suspense fallback={<LoadingModal />}>
        {openResetTrialPopup && (
          <ResetTrialPopup
            user={user}
            onClose={() => setOpenResetTrialPopup(false)}
          />
        )}

        {subscriptionError && <SubscriptionErrorPopup />}
      </Suspense>
    </>
  );
};

export default AuthenticatedLayout;
